import {Component, OnInit} from '@angular/core';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {IntelligenceService} from '../../../services/intelligence.service';
import {IntelligenceSearchInterface} from '../../../models/intelligence-search.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {buildQueryParams, getFiltersFromQueryParams} from '../../../utils/filters-utils';

@Component({
  selector: 'app-visible-fee',
  templateUrl: './visible-fee.component.html',
  styleUrls: ['./visible-fee.component.scss']
})
export class VisibleFeeComponent implements OnInit {

  text = 'Is a fee allowed?';
  subtitle = '';
  years!: number[];
  data!: IntelligenceData[];
  responseType!: string | undefined;

  constructor(private readonly intelligenceService: IntelligenceService,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const search = getFiltersFromQueryParams(params);

      this.intelligenceService.getVisibleFee(search).subscribe(response => {
        this.data = response;
      });
    });
  }

  searchData(event: IntelligenceSearchInterface): void {
    this.responseType = event.responseType;
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: buildQueryParams(event)});
  }

}
